import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import SortByFieldEvent from "../events/sortByFieldEvent";
import { SearchQueryEvent } from "../events/searchQueryEvent";
import { PageChangeEvent } from "../events/pageChangeEvent";
import { FilterChangeEvent } from "../events/filterChangeEvent";
import { PageSizeEvent } from "../events/pageSizeEvent";
import { getInitialQuery } from "../functions/getInitialQuery";
import { QueryChanger } from "../models/queryChanger";
import { FilterBy } from "../models/filterBy";
import { setQueryParameters } from "../functions/setQueryParameters";
import { PageQuery } from "../models/pageQuery";

export function usePageQuery(): [query: PageQuery, setQuery: QueryChanger] {
    const [queryParams, setQParams] = useSearchParams();
    const initialQuery = getInitialQuery(queryParams) ?? {
        page: { size: 20, index: 0 }
    };
    const [currentPageQuery, setPageQuery] = useState<PageQuery>(initialQuery);

    useEffect(() => {
        setQueryParameters(setQParams, currentPageQuery);
    }, [currentPageQuery, setQParams]);

    function handleSortByField(event: SortByFieldEvent) {
        setPageQuery((x) => ({
            ...x,
            sortBy: { field: event.value, direction: event.sortDirection }
        }));
    }

    function handleSearchQueryChange(event: SearchQueryEvent) {
        setPageQuery((x) => ({ ...x, searchTerm: event.searchTerm }));
    }

    function handlePageSizeChange(event: PageSizeEvent) {
        setPageQuery((x) => ({
            ...x,
            page: { ...x.page, size: event.nextSize }
        }));
    }

    function handleNewPage(event: PageChangeEvent) {
        setPageQuery((x) => ({
            ...x,
            page: { ...x.page, index: +event.value }
        }));
    }

    function handleFilterChange(event: FilterChangeEvent) {
        setPageQuery((x) => {
            const newFilters: FilterBy[] = event.activeFilters.map((x) => ({
                field: x.field,
                value: "" + x.value
            }));

            return { ...x, filterBy: newFilters };
        });
    }

    const [queryChanger] = useState({
        handleSortByField,
        handleNewPage,
        handlePageSizeChange,
        handleSearchQueryChange,
        handleFilterChange,
        setPageQuery
    });

    return [currentPageQuery, queryChanger];
}
